import * as actionTypes from "Application/Store/Actions/ViewportTypes"
/*****************************************************************
 *  Viewport Reducer
 * ***************************************************************/

const initialState = {
  viewportMode: 'single',
  mainViewerLayer: 'all',
  comparativeViewerLeftLayer: 'maloc',
  comparativeViewerRightLayer: 'version',
  mainCameraPosition: {},
  strippingVisibility: true,
  attachmentVisibility: true,
  footerVisibility: false,
  versions: [],
  selectedVersion: -1,
  selectedComparativeVersion: -1,
  gridLoaded : false,
  mandiAdjust: { x: 0, y: 0, z: 0 },
  mandiAdjustActive: false,
  gridActive: false,
  viewerType: 'default',
  modifications: null
}

/**
 * Update State
 * @param {object} state 
 * @param {*} action 
 * @returns 
 */
export const ViewportReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.VIEWPORT_MODE:
      return {
        ...state,
        viewportMode: action.payload
      }
    case actionTypes.MAINVIEWER_LAYER:
      return {
        ...state,
        mainViewerLayer: action.payload
      }
    case actionTypes.COMPARATIVEVIEWERLEFT_LAYER:
          return {
              ...state,
              comparativeViewerLeftLayer: action.payload
          }
    case actionTypes.COMPARATIVEVIEWERRIGHT_LAYER:
          return {
              ...state,
              comparativeViewerRightLayer: action.payload
          }
    case actionTypes.MAINCAMERA_POSITION:
      return {
        ...state,
        mainCameraPosition: action.payload
      }
    case actionTypes.STRIPPING_VISIBLE:
      return {
        ...state,
        strippingVisibility: action.payload
      }
    case actionTypes.ATTACHMENT_VISIBLE:
      return {
        ...state,
        attachmentVisibility: action.payload
      }
    case actionTypes.FOOTER_VISIBLE:
      return {
        ...state,
        footerVisibility: action.payload
      }
    case actionTypes.SET_VERSIONS:
      return {
        ...state,
        versions: action.payload
      };
    case actionTypes.SET_SELECTED_VERSION:
      return {
        ...state,
        selectedVersion: action.payload
      };
    case actionTypes.SET_SELECTED_COMPARATIVE_VERSION:
      return {
        ...state,
        selectedComparativeVersion: action.payload
      }
    case actionTypes.MODE:
      return {
        ...state,
        mode: action.payload
      }
    case actionTypes.GRIDLOADED:
      return {
        ...state,
        gridLoaded: action.payload
      }
    case actionTypes.SET_MANDI_ADJUST:
      return {
        ...state,
        mandiAdjust: action.payload
      }
    case actionTypes.TOGGLE_MANDI_ADJUST:
      return {
          ...state,
          mandiAdjustActive: !state.mandiAdjustActive
      }
    case actionTypes.SET_MANDI_ADJUST_ACTIVE:
      return {
          ...state,
          mandiAdjustActive: action.payload
      }
    case actionTypes.GRID_ACTIVE:
      return {
          ...state,
          gridActive: action.payload
      }
    case actionTypes.SET_VIEWER_TYPE:
      return {
          ...state,
          viewerType: action.payload
      }
    case actionTypes.SET_MODIFICATIONS:
      return {
          ...state,
          modifications: action.payload
      }



    default:
      return state
  }
}
